<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    label: string;
    children: Snippet;
  }

  const { label, children }: Props = $props();
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<div class="admin-table-wrap" role="region" tabindex="0" aria-label={label}>
  <table class="admin-table">
    {@render children()}
  </table>
</div>
